import Vue from 'vue';

export default {
    attachWorkLocation(context, locationId) {
        const url = `v1/me/work-locations/${locationId}`;
        return Vue.$axios.$put(url);
    },

    detachWorkLocation(context, locationId) {
        const url = `v1/me/work-locations/${locationId}`;
        return Vue.$axios.$delete(url);
    },
};
